import { api } from 'api';

import { AppThunk } from 'store';
import {
  setError,
  setGoogleMapsCoordinates,
  setIsSvcLocationsLoading,
  setServiceLocations
} from 'store/reducers/locationSlice';

export const getServiceLocations =
  (serviceId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setIsSvcLocationsLoading(true));
      const { data } = await api.locations.getLocationsForService(serviceId);
      dispatch(setServiceLocations({ serviceId, locations: data }));
    } catch (error) {
      console.error(`Error while get service locations: ${error.message}`);
      dispatch(setError(error.response?.data?.error || error.message));
    } finally {
      dispatch(setIsSvcLocationsLoading(false));
    }
  };

export const getGoogleMapsCoordinates =
  (directionUrl: string | null): AppThunk =>
  async (dispatch) => {
    try {
      if (!directionUrl) return;

      const response = await fetch('/api/get-google-coordinates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: directionUrl
        })
      });

      if (!response.ok) {
        console.error(
          'API request failed:',
          response.status,
          response.statusText
        );
        return;
      }

      const data = await response.json();

      if (
        data.success &&
        data.coordinates &&
        data.coordinates.latitude &&
        data.coordinates.longitude
      ) {
        dispatch(
          setGoogleMapsCoordinates({
            url: directionUrl,
            coordinates: data.coordinates
          })
        );
      }
      // success with coordinates: null is normal when a maps URL cannot be geocoded
    } catch (error) {
      console.error(
        'Failed to resolve coordinates from Google Maps URL:',
        error
      );
    }
  };
